import { BaseRootEntity } from '@shared/entity/base-root-entity';
import { Field } from '@tsim/model';

export class ManufacturerEntity extends BaseRootEntity {
  @Field(String, true)
  name!: string;

  @Field(String, false)
  description?: string;

  @Field(String, false)
  weburl?: string;
}
